import Resources, { IResource, IResourceApiModel } from './Resource.model';

export interface IStudioResources {
  id: number;
  resourcesId: string;
  resource: IResource;
}

export interface IStudioResourcesApiModel {
  id: number;
  resourcesId: string;
  resource: IResourceApiModel;
}

export default class StudioResources implements IStudioResources {
  public readonly id: number;

  public readonly resourcesId: string;

  public readonly resource: IResource;

  constructor(id: number, resourcesId: string, resource: IResource) {
    this.id = id;
    this.resourcesId = resourcesId;
    this.resource = resource;
  }

  static fromApiModel(apiModel: IStudioResourcesApiModel) {
    const { id, resourcesId } = apiModel;

    const resource = Resources.fromApiModel(apiModel.resource);
    return new StudioResources(id, resourcesId, resource);
  }

  static arrayFromApiModel(arrayApiModel: IStudioResourcesApiModel[]) {
    const array = arrayApiModel.map(apiModel => {
      const { id, resourcesId } = apiModel;

      const resource = Resources.fromApiModel(apiModel.resource);

      return new StudioResources(id, resourcesId, resource);
    });

    return array;
  }
}
